import { createTranslator, getDefaultLocale } from '@symfony/ux-translator'
import { messages, localeFallbacks } from '../../var/translations'

/*
 * This file wraps Symfony UX Translator (v2.34+).
 * The old API (setLocaleFallbacks, constant exports) was dropped — we now
 * create the translator explicitly and re-export trans + the message-id
 * constants that form-validation.js still imports by name.
 */

const translator = createTranslator({
  messages,
  locale: getDefaultLocale(),
  localeFallbacks
})

export const trans = translator.trans.bind(translator)
export const setLocale = translator.setLocale.bind(translator)
export const getLocale = translator.getLocale.bind(translator)

export const PHANTASIALAND_UI_ERRORS_REQUIRED = 'phantasialand.ui.errors.required'
export const PHANTASIALAND_UI_ERRORS_FIELDSET_REQUIRED = 'phantasialand.ui.errors.fieldsetRequired'
export const PHANTASIALAND_UI_ERRORS_IS_EQUAL = 'phantasialand.ui.errors.isEqual'
export const PHANTASIALAND_UI_ERRORS_EMAIL = 'phantasialand.ui.errors.email'
export const PHANTASIALAND_UI_ERRORS_MINLENGTH = 'phantasialand.ui.errors.minlength'
export const PHANTASIALAND_UI_ERRORS_MAXLENGTH = 'phantasialand.ui.errors.maxlength'
export const PHANTASIALAND_UI_ERRORS_NUMBER = 'phantasialand.ui.errors.number'
export const PHANTASIALAND_UI_ERRORS_MIN = 'phantasialand.ui.errors.min'
export const PHANTASIALAND_UI_ERRORS_MAX = 'phantasialand.ui.errors.max'
export const PHANTASIALAND_UI_ERRORS_NOT_OLD_ENOUGH = 'phantasialand.ui.errors.notOldEnough'
export const PHANTASIALAND_UI_ERRORS_PHONE = 'phantasialand.ui.errors.phone'
export const PHANTASIALAND_UI_ERRORS_TEXT_ONLY = 'phantasialand.ui.errors.textOnly'
export const PHANTASIALAND_UI_ERRORS_NOT_NUMERIC_ONLY = 'phantasialand.ui.errors.notNumericOnly'
